import script from "./PatientsListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientsListPage.vue?vue&type=script&setup=true&lang=js"

import "./PatientsListPage.vue?vue&type=style&index=0&id=10777894&lang=scss"

const __exports__ = script;

export default __exports__